module.exports = __webpack_public_path__ + "img/SuperGoatLife.68eeeb1b.png";